<template>
  <component :is="componentType" :record="record" />
</template>

<script lang="ts">
import { PropType }         from 'vue';
import FeedRecord           from '@/core/services/Feeds/FeedRecord';
import FeedItemChangelog    from './FeedItemChangelog.vue';
import FeedItemComment      from './FeedItemComment.vue';
import FeedItemNotification from './FeedItemNotification.vue';

export default defineComponent({
  name: 'FeedItem',

  props: {
    record: {
      type:     Object as PropType<FeedRecord>,
      required: true,
    },
  },

  computed: {
    componentType() {
      if (this.record.type === 'comment') {
        return FeedItemComment;
      }
      else if (this.record.type === 'notification') {
        return FeedItemNotification;
      }
      else if (this.record.type === 'changelog') {
        return FeedItemChangelog;
      }
      else {
        throw new Error(`Unknown feed item type: ${this.record.type}`);
      }
    },
  },
});
</script>